import type { ButtonVariant } from 'react-bootstrap/types'
import { BusyButton } from '@ztechapps/webui.button'
import type { MessageStatus } from './Context'

export type RefreshChannelButtonProps = {
  onRefresh: () => Promise<void>
  status: MessageStatus
  /** Unset keeps today's default look; the inbox toolbar end slot passes "link" for chromeless chrome. */
  variant?: ButtonVariant
}

export const RefreshChannelButton = ({ onRefresh, status, variant }: RefreshChannelButtonProps) => {
  return (
    <BusyButton
      icon="refresh"
      title="Click here to refresh the conversation"
      aria-label="Refresh the conversation"
      isBusy={status?.loading}
      disabled={status?.sending}
      onClick={() => onRefresh()}
      variant={variant}
    />
  )
}
